import React, { useState } from 'react';
import Header from '../repeat/Header';
import Footer from '../repeat/Footer';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './style/forgot.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";

const Forgot = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isOtpValid, setIsOtpValid] = useState(false);
    const [isPasswordFieldsVisible, setPasswordFieldsVisible] = useState(false);
    const navigate = useNavigate(); // Hook to navigate

    const handlePhoneNumberSubmit = () => {
        fetch('https://gptkpm.in/sendsms.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ phone: phoneNumber })
        })
            .then(response => {
                // Ensure the response is valid JSON
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.status === 'success') {
                    setIsOtpSent(true);
                } else {
                    alert('Phone number not found.');
                }
            })
            .catch(error => {
                console.error('Error in fetch:', error);
                alert('An error occurred while sending OTP.');
            });
    };


    const handleOtpSubmit = () => {
        fetch('https://gptkpm.in/backend/admin/verifyotp.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone: phoneNumber, otp })
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setIsOtpValid(true);
                    setPasswordFieldsVisible(true); // Show username and password change fields
                } else {
                    alert('Invalid OTP');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Error verifying OTP');
            });
    };


    const handlePasswordChange = () => {
        const requestData = {
            phone: phoneNumber,
            newUsername: newUsername,
            newPassword: newPassword
        };
        fetch('https://gptkpm.in/backend/admin/updateusername_password.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    alert('Username and password updated successfully.');
                    navigate('/Admin');
                } else {
                    alert('Error updating user. ' + (data.error || ''));
                }
            });
    };


    return (
        <div>
            <Header />

            <div className="forgot-container">
                {/* <h3>Reset Password</h3> */}
                {!isOtpSent && (
                    <div className='mobile-verification'>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon icon={faShieldAlt} size="2x" color="green" />
                            <h3>Mobile number Verification</h3>
                        </div>
                        <p>Could you please provide the phone number along with(+91) no space between country code and phone number when you rigister or authenticate as admin registrasion EX:+911234567890</p>
                        <input
                            type="text"
                            placeholder="Enter phone number(+91)"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            id='phonenumber'
                        />
                        <button onClick={handlePhoneNumberSubmit}>Send OTP</button>
                    </div>
                )}

                {isOtpSent && !isOtpValid && (
                <div className='otp'>
                    <div className='inner'>
                    <img src="https://cdn-icons-png.freepik.com/256/11191/11191103.png?semt=ais_hybrid" alt="" />
                    <h2>OTP Verification</h2>
                    </div>
                    <input
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                    />
                    <button onClick={handleOtpSubmit}>Submit OTP</button>
                </div>
                )} 

                 {isOtpValid && isPasswordFieldsVisible && ( 
                    <div className='change'>
                        <div className='inner-1'>
                            <img src="data:image/jpeg;base64,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" alt="" />
                            <h2>New Username and Password</h2>
                        </div>
                        <input
                            type="text"
                            placeholder="New Username"
                            value={newUsername}
                            onChange={(e) => setNewUsername(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <button onClick={handlePasswordChange}>Change Username & Password</button>
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
};

export default Forgot;
